import React from 'react'

const Pencil = () => {
  return (
    <svg
      height="20"
      width="20"
      fill="none"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.9472 11.9715L12.4159 5.84704C13.4911 4.82904 13.4079 3.02696 12.2325 1.87139V1.87139C11.0846 0.743035 9.3341 0.665499 8.32235 1.6982L2.03007 8.12075C2.03007 8.12075 3.42395 8.67531 4.40351 9.63827C5.38308 10.6012 5.9472 11.9715 5.9472 11.9715Z"
        fill="#f1f5f9"
        fillRule="evenodd"
        stroke="rgba(226,121,60,0.7)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.52406 13.1143L5.94356 11.9767C5.94356 11.9767 5.38071 10.6059 4.40203 9.64207C3.42335 8.67822 2.02998 8.1224 2.02998 8.1224L0.868044 12.4525C0.766818 12.8297 1.14547 13.2117 1.52406 13.1143Z"
        fill="rgba(42,43,42,0.92)"
        stroke="rgba(226,121,60,0.7)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Pencil
